<div class="main">
    <div id="gamegg-wrapper">
        <div id="pacman" #pacmangame [ngClass]="{'is_hiding': isHiding}">
            <div (click)="closeGame()" class="close-icon">
                &#x2716;
            </div>
        </div>
    </div>
</div>